import { render, staticRenderFns } from "./HolidayOpeningHours.vue?vue&type=template&id=667e71f8&scoped=true&"
import script from "./HolidayOpeningHours.vue?vue&type=script&lang=js&"
export * from "./HolidayOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./HolidayOpeningHours.vue?vue&type=style&index=0&id=667e71f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e71f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('667e71f8')) {
      api.createRecord('667e71f8', component.options)
    } else {
      api.reload('667e71f8', component.options)
    }
    module.hot.accept("./HolidayOpeningHours.vue?vue&type=template&id=667e71f8&scoped=true&", function () {
      api.rerender('667e71f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/HolidayOpeningHours.vue"
export default component.exports